<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('partnersDeposits.form.CreateADepositProcess')"
          :description="$t('partnersDeposits.form.FromHereYouCanCreateANewDepositProcess')"
          v-if="$route.name == 'partnersDepositsCreate'"
        />
        <addHeader
          :title="$t('partnersDeposits.form.ModifyingTheFilingProcess')"
          :description="$t('partnersDeposits.form.FromHereYouCanModifyTheFilingData')"
          v-if="$route.name == 'partnersDepositsEdit'"
        />

        <div class="mb-4 row">
          <connectionInput
            :title="$t('partnersDeposits.form.NumberingTheBatch')"
            :group="$t('partnersDeposits.form.Groups')"
            v-model="item.invoice_group"
            :hasErorr="errors.invoice_group"
            :disabled="$user.admin || $user.role.sales_payments_edit_item ? false : true"
            :error="$t('partnersDeposits.form.ThisFieldIsRequired')"
            :values="$database.invoiceGroups"
            v-if="$route.name == 'partnersDepositsCreate'"
          />
          <formInput
            :title="$t('partnersDeposits.form.OperationCode')"
            v-model="item.code"
            :disabled="true"
            maxlength="255"
            v-if="$route.name == 'partnersDepositsEdit'"
          />
          <subFileInput
            :title="$t('invoices.form.invoiceFile')"
            v-model="item.file"
            :file="item.file"
            :path="'invoices'"
            :hasErorr="errors.file"
            :error="$t('allerts.ChooseASuitableFile')"
          />
          <formInput
            :title="$t('salesPayments.form.reference')"
            v-model="item.refrance"
            maxlength="255"
          />

          <partnerSearchInput :disabled="$route.name == 'invoicesEdit' ? true : false" />

          <monyInput :title="'الرصيد'" v-model="item.partner.balance" disabled="true" />

          <div class="form-group row" :class="'col-md-6'">
            <label :class="'col-md-4'">{{
              $t('partnersDeposits.form.TheHistoryOfTheOperation')
            }}</label>
            <div :class="'col-md-7'">
              <div class="icon-input w-100 to-left">
                <span><i class="far fa-calendar"></i></span>
                <VueCtkDateTimePicker
                  :label="$t('partnersDeposits.form.ChooseTimeAndDate')"
                  :button-now-translation="$t('partnersDeposits.form.Now')"
                  v-model="item.date"
                  :disabled="$user.admin || $user.role.sales_payments_edit_item ? false : true"
                  format="YYYY-MM-DD hh:mm a"
                  color="#631263"
                  button-color="#631263"
                />
              </div>
            </div>
          </div>

          <searchGroupInput
            :type="'project'"
            :values="$database.projects"
            :inputs="[{ title: $t('partnersDeposits.form.Project'), show: 'name' }]"
            v-if="$site.projects_allow"
          />

          <connectionInput
            :disabled="item.project_id == 0"
            :title="$t('partnersDeposits.form.ProjectOutput')"
            :group="$t('partnersDeposits.form.ProjectOutputs')"
            v-model="item.project_item_id"
            :values="$database.projectItems.filter((el) => el.project_id == item.project_id)"
            v-if="$site.projects_allow"
          />

          <selectInput
            :title="$t('invoices.form.Situation')"
            v-model="item.status"
            :values="[
              { name: $t('invoices.draft'), value: 0 },
              { name: $t('invoices.approved'), value: 1 }
            ]"
          />

          <dvider
            :title="$t('partnersDeposits.form.accountsInformation')"
            :description="$t('partnersDeposits.form.AccountInformationDetails')"
          />

          <monyInput
            :title="$t('partnersDeposits.form.cash')"
            v-model="item.cost"
            :hasErorr="errors.cost"
            :error="$t('allerts.theAmountReceivedMustBeGreaterThan')"
          />

          <searchGroupInput :type="'safe'" :values="$database.safes" :inputs="[{ show: 'name' }]" />
          <searchGroupInput
            :type="'paymentMethod'"
            :values="$database.paymentMethods"
            :inputs="[{ show: 'name' }]"
          />

          <div class="col-6"></div>

          <dvider
            :title="$t('partnersDeposits.form.notes')"
            :description="$t('partnersDeposits.form.PaymentNotes')"
          />

          <formTextarea :title="$t('partnersDeposits.form.thatAbout')" v-model="item.description" />
          <formTextarea :title="$t('partnersDeposits.form.note')" v-model="item.notes" />
          <hr class="mt-5 mb-5 col-12" />
          <a
            @click="saveItem()"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'partnersDepositsCreate' && !$parent.stopEdit"
          >
            {{ $t('partnersDeposits.form.AddAnOperation') }}
          </a>
          <a
            @click="saveItem()"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'partnersDepositsEdit' && !$parent.stopEdit"
          >
            {{ $t('partnersDeposits.form.ProcessModification') }}
          </a>
          <loading v-if="$parent.stopEdit" />
        </div>
      </div>
    </div>
    <addPaymentMethod v-if="model == 'addPaymentMethod'" />
    <addPaymentFee v-if="model == 'addPaymentFee'" />
  </div>
</template>
<script>
import axios from 'axios'

import formInput from '@/elements/add/form/formInput.vue'
import formTextarea from '@/elements/add/form/formTextarea.vue'
import connectionInput from '@/elements/add/form/connectionInput.vue'
import monyInput from '@/elements/add/form/monyInput.vue'
import selectInput from '@/elements/add/form/selectInput.vue'
import checkInput from '@/elements/add/form/checkInput.vue'
import dvider from '@/elements/add/dvider.vue'
import addHeader from '@/elements/add/header.vue'
import loading from '@/elements/add/loading.vue'
import subFileInput from '@/elements/add/form/subFileInput.vue'

import addPaymentMethod from '@/elements/popupForms/addPaymentMethod.vue'
import addPaymentFee from '@/elements/popupForms/addPaymentFee.vue'

import customerTaxIdInput from '@/elements/add/form/search/customerTaxIdInput.vue'
import customerSearchInput from '@/elements/add/form/search/customerNameInput.vue'

import supplierTaxIdInput from '@/elements/add/form/search/supplierTaxIdInput.vue'
import supplierSearchInput from '@/elements/add/form/search/supplierNameInput.vue'

import partnerTaxIdInput from '@/elements/add/form/search/partnerTaxIdInput.vue'
import partnerSearchInput from '@/elements/add/form/search/partnerNameInput.vue'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import searchGroupInput from '@/elements/add/form/searchGroupInput.vue'

export default {
  data() {
    return {
      path: '/partnersDeposits',
      item: {
        invoice_group: this.$option.partners_deposits_invoice_group_id,
        partner_id: 0,
        project_id: 0,
        project: {},
        project_item_id: 0,
        partner: {
          name: '',
          mobile: '',
          address1: '',
          balance: 0
        },
        safe: {},
        paymentMethod: {},

        payment_method_id: 0,
        safe_id: 0,
        date: '',
        status: 1
      },
      model: false,
      errors: {
        invoice_group: false,
        name: false,
        cost: false,
        safe_id: false
      },
      print: this.$route.name == 'partnersDepositsCreate' ? true : false
    }
  },
  mounted() {
    this.$updateDatabase([
      'invoiceGroups',
      'partners',
      'projects',
      'projectItems',
      'safes',
      'paymentMethods'
    ])

    if (this.$route.name == 'partnersDepositsEdit') {
      this.$parent.stopEdit = true
      this.getItem()
    } else {
      if (this.$database.safes.length == 1) {
        this.item.safe_id = this.$database.safes[0].id
      }

      var params = this.$getParams()
      if (params.partner_id) {
        var partner = this.$database.partners.find((el) => el.id == params.partner_id)
        this.item.partner_id = params.partner_id
        this.item.partner = partner
      }
    }
    if (this.$route.name == 'partnersDepositsCreate') {
      this.item.date = this.$nowDate()
    }
    var elm = this
    window.addEventListener('keydown', function (e) {
      if (e.key == 'F1' || e.key == 'Meta') {
        e.preventDefault()
        elm.saveItem()
      }
    })
  },
  methods: {
    getItem() {
      axios.get(this.$linkGnirator(this.path + '/' + this.$route.params.id)).then((response) => {
        this.item = response.data
        this.$parent.stopEdit = false
        this.item.date = this.$dateFormat(this.item.date, true)
      })
    },
    saveItem() {
      var error = 0
      if (typeof this.item.partner_id === 'undefined' || this.item.partner_id == '') {
        error = 1
        this.errors.name = true
      }
      if (typeof this.item.cost === 'undefined' || this.item.cost == '' || this.item.cost == 0) {
        error = 1
        this.errors.cost = true
      }
      if (
        (typeof this.item.invoice_group === 'undefined' ||
          this.item.invoice_group == 0 ||
          this.item.invoice_group == '' ||
          this.item.invoice_group == null) &&
        this.$route.name == 'partnersDepositsCreate'
      ) {
        error = 1
        this.errors.invoice_group = true
      }
      if (this.$route.name == 'partnersDepositsCreate') {
        if (
          typeof this.item.safe_id === 'undefined' ||
          this.item.safe_id == '' ||
          this.item.safe_id == 0
        ) {
          error = 1
          this.errors.safe_id = true
        }
      }
      if (error == 0) {
        this.item.date = this.$fixDate(this.item.date)
        if (this.$route.name == 'partnersDepositsCreate') {
          this.$parent.aletText = this.$t('allerts.partnersDepositsuccessfullyAdde')
          this.$parent.alertType = 'success'
          this.$addToLocalDatabase(this.item, this.path.substring(1))

          this.item.old_balance = this.item.partner.balance
          this.item.new_balance = parseFloat(this.item.old_balance) + parseFloat(this.item.cost)

          // update partner balance
          var partner = this.$database.partners.find((el) => el.id == this.item.partner_id)
          if (partner) {
            partner.balance = this.item.new_balance
          }
          // update safe balance
          var safe = this.$database.safes.find((el) => el.id == this.item.safe_id)
          if (safe) {
            safe.balance = parseFloat(safe.balance) + parseFloat(this.item.cost)
          }

          localStorage.database = JSON.stringify(this.$database)

          this.$router.go(-1)
          this.$parent.stopEdit = false

          if (this.$option.print_after) {
            var today = new Date()
            var date = today.getFullYear() + '/' + (today.getMonth() + 1) + '/' + today.getDate()
            var time = today.getHours() + ':' + today.getMinutes()

            var hours = today.getHours()
            var minutes = today.getMinutes()
            var ampm = hours >= 12 ? 'pm' : 'am'
            hours = hours % 12
            hours = hours ? hours : 12
            minutes = minutes < 10 ? '0' + minutes : minutes
            var time = hours + ':' + minutes + ' ' + ampm

            this.item.date = date
            this.item.time = time

            this.item.created_at = new Date().toISOString('ar-EG', {
              timeZone: 'Africa/Cairo'
            })
            this.$parent.printedSalesPayment = this.item
          }
        } else if (this.$route.name == 'partnersDepositsEdit') {
          this.item._method = 'PUT'
          this.$parent.stopEdit = true
          axios
            .post(this.$linkGnirator(this.path + '/' + this.item.id), this.item)
            .then((response) => {
              if (response.data == 'safe error') {
                this.$parent.aletText = 'الموظف غير مربوط بخزينة'
                this.$parent.alertType = 'danger'
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                })
              } else {
                this.$parent.aletText = this.$t('allerts.salesPaymentHasBeenModifiedSuccessfully')
                this.$parent.alertType = 'success'
                this.$router.go(-1)
                this.$parent.stopEdit = false
                return response
              }
            })
        }
      } else {
        this.$parent.aletText = this.$t('allerts.pleaseMakeSureOfTheInput')
        this.$parent.alertType = 'danger'
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  watch: {
    selectedPaymentFees: function (val) {
      this.item.payment_fee_id = val.map((el) => el.id)
    }
  },

  components: {
    formInput,
    dvider,
    addHeader,
    monyInput,
    selectInput,
    formTextarea,
    connectionInput,
    checkInput,
    addPaymentMethod,
    addPaymentFee,
    loading,

    customerTaxIdInput,
    customerSearchInput,

    supplierTaxIdInput,
    supplierSearchInput,

    partnerTaxIdInput,
    partnerSearchInput,

    VueCtkDateTimePicker,
    searchGroupInput,
    subFileInput
  }
}
</script>
